var map = {
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"authentication-authentication-module"
	],
	"./clients/clients.module": [
		"./src/app/clients/clients.module.ts",
		"default~clients-clients-module~furnishers-furnishers-module~management-management-module",
		"default~clients-clients-module~furnishers-furnishers-module~orders-orders-module",
		"clients-clients-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./finance/finance.module": [
		"./src/app/finance/finance.module.ts",
		"finance-finance-module"
	],
	"./furnishers/furnishers.module": [
		"./src/app/furnishers/furnishers.module.ts",
		"default~clients-clients-module~furnishers-furnishers-module~management-management-module",
		"default~clients-clients-module~furnishers-furnishers-module~orders-orders-module",
		"furnishers-furnishers-module"
	],
	"./management/management.module": [
		"./src/app/management/management.module.ts",
		"default~clients-clients-module~furnishers-furnishers-module~management-management-module"
	],
	"./orders/orders.module": [
		"./src/app/orders/orders.module.ts",
		"default~clients-clients-module~furnishers-furnishers-module~orders-orders-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;